import { Link } from 'react-router-dom';

function ActionCard({
  title,
  description,
  path = '#',
  symbol = '+',
}) {
  return (
    <Link
      to={path}
      className="quick-action-card"
    >
      <span className="quick-action-card__icon">
        <span className="quick-action-card__symbol">
          {symbol}
        </span>
      </span>

      <span className="quick-action-card__content">
        <strong>
          {title}
        </strong>

        <small>
          {description}
        </small>
      </span>

      <span className="quick-action-card__arrow">
        ↗
      </span>
    </Link>
  );
}

export default ActionCard;